// extracted by mini-css-extract-plugin
module.exports = {"dot":"_2d1gz","active":"_29JzS","container":"_3qHeu"};